// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulpu2gc{gap:var(--ds-space-100,8px)}._18u01ejb{margin-left:var(--ds-space-300,24px)}\n._19pkze3t{margin-top:var(--ds-space-0,0)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._2hwx1ejb{margin-right:var(--ds-space-300,24px)}\n._2lx21bp4{flex-direction:column}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}\n._otyr1ejb{margin-bottom:var(--ds-space-300,24px)}\n._syaz1fxt{color:var(--ds-text,#172b4d)}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
